import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/General/Text/text.container"
    ).then((module) => ({
        default: module.TextContainer
    }))
);
